import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextBadge from '@dbk/ui-text-badge';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Small, Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import PlayStoreLogo from '../../../../public/images/play-store-logo.png';
import { EBANKINGWEBLUX, EBANKINGWEB} from '../../../constants';
// import envConfig from '../../../../../db-env-build';
import envConfig from '../../../../db-env-build';
import AppStoreLogo from '../../../../public/images/app-store-logo.png';
import IosQRcodeLux from '../../../../public/images/lux/QR_LUX_iOS.png';
import AndroidQRcodeLux from '../../../../public/images/lux/QR_LUX_Android.png';
import IosQRcode from '../../../../public/images/qr-code-ios.png';
import AndroidQRcode from '../../../../public/images/qr-code-android.png';
import IosQRcodeUK from '../../../../public/images/UK/QR_UK_iOS.png';
import AndroidQRcodeUK from '../../../../public/images/UK/QR_UK_Android.png';

class NtbModal extends PureComponent {

  closeModal = () => {
    this.props.vascoauthentication.onHideVasco();
    this.props.vascoauthentication.setVascoModalType(null);
  }

  componentDidUpdate(e){
    // if(document.querySelector('.content__step1')){
    //   document.querySelector('.content__step1').focus();
    // }
    if(document.querySelector('.ModalHeader h5')){
      document.querySelector('.ModalHeader h5').focus();
    }
  }

  renderModal = () => {
    const { i18n: { messages }, isMobileGuide } = this.props;
    return(
      <div className='content'>
        <div tabIndex={0} className='content__step1'>
          {!isMobileGuide && <div className='content__step1__badge'>
            <TextBadge value={1} size='medium' tertiary className="content__step1__badge__style"/>
          </div>}
          <div className='content__step1__message'>
            <Large>{(envConfig.envConfig === EBANKINGWEBLUX) ? messages["app.auth.ntbModal.step1.message.lux"] :  messages["app.auth.ntbModal.step1.message"]}</Large><br/>
            {!isMobileGuide &&  <Text>{messages["app.auth.ntbModal.step1.secutiryText"]}</Text>}
          </div>
        </div>
        <div className='content__space'></div>
        {!isMobileGuide && <div tabIndex={0} className='content__step1'>
          <div className='content__step1__badge'>
            <TextBadge value={2} size='medium' tertiary className="content__step1__badge__style"/>
          </div>
          <div className='content__step1__message'>
            <Large>{messages["app.auth.ntbModal.step2.message"]}</Large><br/>
          </div>
        </div>}
        <div className='content__space'></div>
        <div className='qr-codes'>
          <div className='qr-codes__ios' tabIndex={0}>
            <div className='qr-codes__ios__message'>
              <div><Small>{messages["app.auth.ntbModal.iosQrCodeScanText"]}</Small></div>
              <div><img alt={messages['app.accessibility.ntb.appStoreIcon']} src={AppStoreLogo} className='qr-codes__ios__message__logo'/></div>
            </div>
            <div>
              <img alt={messages['app.accessibility.ntb.iOSQRScancode']} src={(envConfig.envConfig === EBANKINGWEBLUX) ? IosQRcodeLux :  (envConfig.envConfig === EBANKINGWEB) ? IosQRcode : IosQRcodeUK} className='qr-codes__ios__code'/>
            </div>
          </div>
          <div className='qr-codes__ios' tabIndex={0}>
            <div className='qr-codes__ios__message'>
              <div><Small>{messages["app.auth.ntbModal.androidQrCodeScanText"]}</Small></div>
              <div>
                <img alt={messages['app.accessibility.ntb.appStoreIcon']} src={PlayStoreLogo} className='qr-codes__ios__message__logo'/>
              </div>
            </div>
            <div>
              <img alt={messages['app.accessibility.ntb.androidQRScancode']} src={(envConfig.envConfig === EBANKINGWEBLUX) ? AndroidQRcodeLux :  (envConfig.envConfig === EBANKINGWEB) ? AndroidQRcode : AndroidQRcodeUK} className='qr-codes__ios__code'/>
            </div>
          </div>
        </div>
        <div className='content__space'></div>
        {!isMobileGuide && <div>
          <Small tabIndex={0}>{messages["app.auth.ntbModal.regisCompletedText"]}</Small>
        </div>}
        <div className='content__space'></div>
        <div className='content__button'>
          <div>
            <Button
              onPress={this.props.closeModal}
            >{messages["app.common.closeText"]}</Button>
          </div>
        </div>
      </div>
    )
  }

  render(){
    return (
      <div>
        {this.renderModal()}
      </div>
    )
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    vascoauthentication: {
      onHideVasco: { $call: 'hideVasco' },
      setVascoModalType: { $set: 'vascoModalType'}
    }
  }
})(NtbModal);

NtbModal.PropTypes = {
  isMobileGuide: PropTypes.bool,
  closeModal: PropTypes.func
};

NtbModal.defaultProps = {
  isMobileGuide: false,
  closeModal: () => {}
};
